import { useHouseholds } from '@platewell/query';
import type { Session } from '../../lib/api.js';
import { DeleteAccountSection } from './delete-account.js';

/**
 * Who you are, and which households you belong to.
 *
 * The session is passed in rather than fetched again: the page above already holds it to
 * decide whether the Security tab is offered at all.
 */
export function AccountTab({ session }: { session: Session | null }) {
  const { households, activeHouseholdId, setActiveHousehold } = useHouseholds();

  const user = session?.user;
  const name = user?.name?.trim() || null;

  return (
    <>
      <section className="section-group">
        <h2 className="section-title">You</h2>
        <div className="kv">
          <span>Name</span>
          <span className={name == null ? 'hint' : undefined}>{name ?? 'Not set'}</span>
        </div>
        {user?.email != null && (
          <div className="kv">
            <span>Email</span>
            <span>{user.email}</span>
          </div>
        )}
      </section>

      <section className="section-group">
        <h2 className="section-title">Households</h2>
        {households.map((household) => {
          const isActive = household.id === activeHouseholdId;
          return (
            <div className="kv" key={household.id}>
              <span>
                {household.name}
                {isActive && <span className="hint"> · active</span>}
              </span>
              <span className="row" style={{ gap: 10 }}>
                <span className="hint">{household.role}</span>
                {!isActive && (
                  <button className="btn ghost" onClick={() => setActiveHousehold(household.id)}>
                    Switch
                  </button>
                )}
              </span>
            </div>
          );
        })}
        {households.length === 0 && <p className="hint">No households yet.</p>}
      </section>

      {/* Hidden while impersonating: the server would refuse it, and it would be the
          agent's account it acted on, not the customer's on screen. */}
      {session != null && session.impersonation == null && <DeleteAccountSection />}
    </>
  );
}
